// extracted by mini-css-extract-plugin
export var chevronIcon = "_7k-2";
export var teamName = "_7k-1";
export var teamSwitcherButton = "_7k-0";